// Common
import { useState, useCallback, useEffect } from 'react'

export default function useWindowsSize(): number {
	const getWidth = useCallback(() => {
		return window.innerWidth
	}, [])

	const [width, setWidth] = useState(getWidth())

	const handleResize = useCallback(() => {
		setWidth(getWidth())
	}, [setWidth, getWidth])

	useEffect(() => {
		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [handleResize])

	return width
}
